var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgFiremapAssetHistoricSite = function SvgFiremapAssetHistoricSite(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 24 24"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    fillRule: "evenodd",
    d: "M4 4h16v16H4zM2 22V2h20v20zM15.472 8.805c-1.561 0-2.588.768-2.588 1.972 0 1.332 1.193 1.641 2.137 1.886.618.16 1.13.292 1.13.667 0 .285-.25.42-.643.42-.642 0-1.687-.411-2.33-.956l-.695 1.41c.785.616 1.945.991 3.007.991 1.401 0 2.58-.634 2.58-1.963 0-1.379-1.218-1.713-2.166-1.973-.605-.166-1.1-.302-1.1-.66 0-.232.204-.34.517-.34.526 0 1.437.331 2.08.697l.686-1.428c-.678-.437-1.66-.723-2.615-.723m-3.625 6.337V8.885H9.991v2.49H7.769v-2.49H5.912v6.257H7.77v-2.33H9.99v2.33z",
    clipRule: "evenodd"
  })));
};
export default SvgFiremapAssetHistoricSite;